import { Role } from "./roles.model";
import { Commercial } from "./commercials.model";
import { Locality } from "./localities.model";
import { Site } from "./sites.model";

export class User {
  id: number;
  username: string;
  rawPassword: string;
  enabled: boolean;
  description: string;
  createAt: Date;
  type: UserType;
  loginLast: LoginInfo;
  roles: Role[];
  commercials: Commercial[];
  manager: Manager;
  site: Site;

  constructor() {
    this.enabled = true;
    this.description = '';
    this.createAt = new Date();
    this.roles = [];
    this.commercials = [];
    this.manager = new Manager();
    this.site = null as any; // set explicitly where needed
  }
}

export class Manager {
  id: number;
  username: string;
  enabled: boolean;
  description: string;
  createAt: Date;
  type: UserType;
  loginLast: LoginInfo;
  roles: Role[];
  commercials: Commercial[];

  constructor() {
    this.enabled = true;
    this.description = '';
    this.createAt = new Date();
    this.roles = [];
    this.commercials = [];
  }
}

export class UserForm {
  id: number;
  username: string;
  password: string;
  enabled: boolean;
  description: string;
  createAt: Date;
  roles: number[];
  commercials: Commercial[];
  usersToManaged: number[];
  siteId: number;

  constructor() {
    this.enabled = true;
    this.description = '';
    this.createAt = new Date();
    this.roles = [];
    this.usersToManaged = [];
  }
}

export enum UserType {
  commercial = "commercial",
  admin = "admin",
  commercial_manager = "commercial_manager",
  regional_manager = "regional_manager",
  commercial_director = "commercial_director",
  director_general = "director_general",
  manager_site = "manager_site",
  sales_force = "sales_force",
}

export class LoginInfo {
  id: number;
  locality: Locality;
  loginAt: Date;

  constructor() {
    this.loginAt = new Date();
  }
}
